import { observer } from "mobx-react";
import { IAppliedFilterChipComponent } from "../BaseChipComponents/IAppliedFilterChipComponent";
import AppliedFilterChip from "../BaseChipComponents/AppliedFilterChipBase";
import React from "react";
import { useChipFiltersStore } from "../BaseChipComponents/chipUtils";

export const LanguageChips = observer(function (
    props: IAppliedFilterChipComponent,
) {
    const applicationFiltersStore = useChipFiltersStore(props);

    return applicationFiltersStore.languages.map((language) => (
        <AppliedFilterChip
            key={language.languageValue}
            disabled={props.disabled}
            isApplicable={props.isApplicable}
            onRemove={() =>
                applicationFiltersStore.setLanguages(
                    (applicationFiltersStore.languages ?? []).filter(
                        (x) => x.languageValue !== language.languageValue,
                    ),
                )
            }
        >
            Language: {
                applicationFiltersStore.languageOptions.find(
                    (option) => option.value === language.languageValue,
                )?.label as string
            }
        </AppliedFilterChip>
    ));
});
